import React from "react";
import { useTranslation } from "react-i18next";

// Assets
import facebook from "assets/images/facebook-color.svg";
import google from "assets/images/google-color.svg";

// Style
import {
  Container,
  ButtonsContainer,
  LinkButton,
  Image,
  Text,
  ContainerMobile,
  Label,
  ButtonsContainerMobile,
  IconMobile,
  LinkButtonMobile
} from "./SocialButtons.style";

export const SocialButtons = ({ isFormActive, isPhone }) => {
  const { t } = useTranslation();
  const social = [
    {
      id: "google",
      icon: google,
      color: "light",
      link: `${process.env.REACT_APP_API_URL}/auth/google`,
      text: t("SocialButton.Google.Login")
    },
    {
      id: "facebook",
      icon: facebook,
      color: "dark",
      link: `${process.env.REACT_APP_API_URL}/auth/facebook`,
      text: t("SocialButton.Facebook.Login")
    }
  ];
  const socialButtons = (
    <Container>
      <ButtonsContainer>
        {social.map(elem => {
          const { id, link, icon, text, color } = elem;
          return (
            <LinkButton
              color={color}
              href={link}
              data-cy={`social-${id}`}
              title={text}
              key={`LinkButton-${id}`}
            >
              <Image src={icon} alt={`Icon - ${id}`} />
              <Text>{text}</Text>
            </LinkButton>
          );
        })}
      </ButtonsContainer>
    </Container>
  );

  const socialButtonsMobileFormActive = (
    <ContainerMobile>
      <Label>{t("SocialButton.Login.Mobile")}</Label>
      <ButtonsContainerMobile>
        {social.map(elem => {
          const { id, link, icon, text } = elem;
          return (
            <LinkButtonMobile href={link} data-cy={`social-${id}`} title={text} key={`LinkButton-${id}`}>
              <IconMobile src={icon} alt={`Icon - ${id}`} />
            </LinkButtonMobile>
          );
        })}
      </ButtonsContainerMobile>
    </ContainerMobile>
  );

  if (isPhone) {
    return isFormActive ? socialButtonsMobileFormActive : socialButtons;
  }

  return socialButtons;
};
